import React, { Component } from 'react'
import { Check } from 'react-feather'
import Input from './Input'
import Button from './Button'

class InputEnter extends Component {
	render() {
		const { value, type = 'text', showEnterButton = true } = this.props

		return (
			<div>
				<Input
					placeholder={this.props.placeholder}
					containerStyle={{
						width:
							value.length > 0 && showEnterButton
								? 'calc(100% - 48px)'
								: 'calc(100% - 0px)',
						display: 'inline-block',
						verticalAlign: 'bottom',
						transition: 'all 0.4s',
					}}
					onChange={(e) => {
						this.setState({
							value: e.target.value,
						})
						return this.props.onChange ? this.props.onChange(e) : null
					}}
					value={value}
					onKeyDown={(e) => {
						if (e.key === 'Enter' && value.length > 0)
							return this.props.onEnter ? this.props.onEnter(value) : null
					}}
					type={type}
				/>
				{showEnterButton ? (
					<Button
						style={{
							width: value.length > 0 ? '43px' : '0px',
							marginLeft: value.length > 0 ? '5px' : '0px',
							paddingLeft: value.length > 0 ? '15px' : '0px',
							paddingRight: value.length > 0 ? '15px' : '0px',
							display: 'inline-flex',
							verticalAlign: 'bottom',
							transition: 'all 0.4s',
						}}
						onClick={() => {
							return this.props.onEnter ? this.props.onEnter(value) : null
						}}
						disabled={this.props.disabled || false}
					>
						<Check size={16} />
					</Button>
				) : null}
			</div>
		)
	}
}

export default InputEnter
